
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M918.613 363.947L896 469.333l-22.613-105.386L768 341.333l105.387-22.613L896 213.333l22.613 105.387L1024 341.333l-105.387 22.614zm-64-213.334L832 256l-22.613-105.387L704 128l105.387-22.613L832 0l22.613 105.387L960 128l-105.387 22.613zM512 64v42.667c-223.85 0-405.333 181.482-405.333 405.333S288.149 917.333 512 917.333 917.333 735.851 917.333 512H960c0 247.424-200.576 448-448 448S64 759.424 64 512 264.576 64 512 64zM346.07 697.75l30.165-30.166a192 192 0 00271.53 0l30.166 30.165c-91.648 91.648-240.214 91.648-331.862 0zm16.597-164.417a64 64 0 110-128 64 64 0 010 128zm298.666 0a64 64 0 110-128 64 64 0 010 128zm-20.053-318.72L618.667 320l-22.614-105.387L490.667 192l105.386-22.613L618.667 64l22.613 105.387L746.667 192 641.28 214.613z"}})])
          )
        }
      }
    